import { IMoneyData } from '@blackcart/base';
import clsx from 'clsx';
import React, { FC, forwardRef } from 'react';
import { useBlackcart } from '../../context';
import styles from './CartSubtotalWrapper.module.css';

export type CartSubtotalWrapperProps = {
  labels?: {
    deposit?: string;
    payToday?: string;
  };
  render?: (P: {
    isTBYBQualifiedCart: () => boolean;
    deposit: IMoneyData;
    payTodayTotal: IMoneyData;
  }) => JSX.Element;
} & React.HTMLProps<HTMLDivElement>;

const CartSubtotalWrapper: FC<CartSubtotalWrapperProps> = forwardRef<
  HTMLDivElement,
  CartSubtotalWrapperProps
>(({ labels, render, children }, ref) => {
  const context = useBlackcart();
  const { isTBYBQualifiedCart, deposit, payTodayTotal } = context;

  if (isTBYBQualifiedCart()) {
    if (render) {
      render({ isTBYBQualifiedCart, deposit, payTodayTotal });
    } else {
      return (
        <div className={clsx([styles.root, 'bc-CartSubtotal__root'])} ref={ref}>
          {deposit && (
            <TotalRow
              className="bc-CartSubtotal__row--deposit"
              label={labels?.deposit || 'Try Before You Buy Deposit'} //
              amount={deposit.formatted}
            />
          )}
          <TotalRow
            className="bc-CartSubtotal__row--payToday"
            label={labels?.payToday || 'Pay Today'}
            amount={payTodayTotal.formatted}
          />
        </div>
      );
    }
  } else {
    return <>{children}</>;
  }
});

// ELEMENTS ////////////////

type TotalRowProps = { label: string; amount: string; className: string };
const TotalRow: FC<TotalRowProps> = (props) => (
  <div className={clsx([styles.row, 'bc-CartSubtotal__row', props.className])}>
    <div className={clsx([styles.rowLabel, 'bc-CartSubtotal__row-label'])}>{props.label}</div>
    <div className={clsx([styles.rowAmount, 'bc-CartSubtotal__row-amount'])}>{props.amount}</div>
  </div>
);

export { CartSubtotalWrapper };
